/** English (default) — nested keys for i18next (`t('header.title')`). */
export const en = {
  header: {
    brandAlt: 'Avatar',
    /** `{{name}}` from GET /v1/config.name (falls back to brandAlt). */
    title: 'Chat with {{name}}',
    subtitle: 'Ask, discover, or get help instantly',
    reset: 'Reset conversation',
  },
  chat: {
    typing: 'Avatar is typing…',
    errorFallback:
      "Sorry about this. I'm unable to assist with your request right now due to a temporary issue on our side. Please try again shortly.",
    networkError: 'Network error. Please check your connection and try again.',
    widgetDisabled:
      'This chat is no longer available. New messages cannot be sent right now.',
    originNotAllowlisted:
      "This site is not allowlisted for this avatar. Ask your admin to add '{{origin}}'.",
    bundleNotAllowlisted:
      "This app is not allowlisted for this avatar. Ask your admin to add '{{bundle}}'.",
    identifyDisabled: 'Identity verification is disabled for this avatar.',
    identifyRequired:
      'Sign in is required for this avatar. Call identify(userId, hmac) before chatting.',
    retry: 'Try again',
    streamingPlaceholder: '…',
    newConversationStarted: 'New conversation started',
    yesterday: 'Yesterday',
  },
  input: {
    placeholder: 'Ask anything...',
    ariaLabel: 'Message Avatar',
    send: 'Send message',
    poweredBy: 'Powered by Avatar.inc',
  },
  popular: {
    ariaLabel: 'Suggested questions',
  },
  mobile: {
    subtitle: 'Your AI assistant for {{name}}.',
    hello: "Hello, I'm {{name}}",
    heroBody:
      'I can help you discover, create, and get the most out of your {{name}}.',
    heroHint: 'Select a question below or type a message.',
    heroHintVoice:
      'Select a question below or tap the microphone to ask by voice.',
    popularHeading: 'Popular Questions',
    placeholder: 'Ask {{name}}...',
    back: 'Close',
    mic: 'Voice input',
  },
  doc: {
    title: 'Avatar Widget',
  },
} as const;

/** Same tree as `en`, but values are plain strings (other locales). */
export type EnTranslation = {
  [K in keyof typeof en]: {
    [P in keyof (typeof en)[K]]: string;
  };
};
